/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/
import borderRadius from '../scss/borderRadius.module.scss';

type BorderRadius = {
  cornerRadius0: string;
  cornerRadius1: string;
  cornerRadius2: string;
  cornerRadius3: string;
  cornerRadius4: string;
  cornerRadius5: string;
  cornerRadius6: string;
  cornerRadiusFull: string;
};
/**
 * Export border radius tokens
 * @public
 */
export default borderRadius as unknown as BorderRadius;
